import { useEffect, useRef } from 'react';
import { propEq, prop, isNotNil } from 'ramda';
import { AUTH_LOGOUT_STORAGE_KEY, AUTH_LOGGED_OUT_ELSEWHERE_PARAM } from '../_CONST';

const reloadPage = () => window.location.assign(`/account/signin?${AUTH_LOGGED_OUT_ELSEWHERE_PARAM}`);

const isLogoutEvent = (event) => propEq(AUTH_LOGOUT_STORAGE_KEY, 'key', event) && isNotNil(prop('newValue', event));

const useAuthLogoutSync = (onLogout = reloadPage) => {
  const onLogoutRef = useRef(onLogout);
  useEffect(() => { onLogoutRef.current = onLogout; }, [onLogout]);

  useEffect(() => {
    const handleStorageChange = (event) => isLogoutEvent(event) && onLogoutRef.current();
    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);
};

export default useAuthLogoutSync;